import { NODE_GROUP_MIN_SIZE } from "Areas/Documents/graph/constants";
import GroupNodesSource from "Areas/Documents/graph/types/groupNodesSource";
import { Rect } from "yfiles";
export const addHiddenGroup = ({ graphComponentRef, documentObjects, groupsData = [], groupIds, groupedNodesMap }) => {
    var _a;
    const groupMap = new Map((_a = [...groupsData]) === null || _a === void 0 ? void 0 : _a.map(item => [item.Id, item]));
    const newGroups = {};
    if (documentObjects) {
        groupIds
            .filter(item => !groupedNodesMap[item])
            .forEach(groupId => {
            var _a;
            const groupData = groupMap.get(groupId);
            if (groupData && graphComponentRef.current) {
                const groupLayout = new Rect(20, 20, NODE_GROUP_MIN_SIZE.width, NODE_GROUP_MIN_SIZE.height);
                const groupNode = (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.createGroupNode({
                    layout: groupLayout,
                    tag: new GroupNodesSource(groupData.Id, [], documentObjects, groupLayout.width, groupLayout.height, groupData.Name, 0)
                });
                graphComponentRef.current.graph.setIsGroupNode(groupNode, true);
                newGroups[groupId] = groupNode;
            }
        });
    }
    return { groupedNodesMap: { ...groupedNodesMap, ...newGroups }, newGroups };
};
